module.exports = __webpack_public_path__ + "static/media/facebook.c648094b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Footer/img/facebook.svg
// module id = 143
// module chunks = 0